/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Accordion, Text } from '@az/starc-ui';
import { Grid } from '@/components/Grid';
import cx from 'classnames';
import styles from './FaqItem.module.scss';
import { useCMSRichTextModal } from '@/features/contentstack/hooks/useCMSRichTextModal';

type Props = {
  question: string;
  answer: string;
  icon?: string;
  isGridTheme: boolean;
  fontSize?: 'small' | 'medium';
};

export const FaqItem = ({ isGridTheme, question, answer, icon, fontSize }: Props) => {
  const fontSizeValue = fontSize === 'medium' ? '087' : '075';

  const { processedHTML, handleClick, ModalComponents } = useCMSRichTextModal(answer);

  if (isGridTheme) {
    return (
      <Grid item xs={12} lg={6} className={styles.gridItem}>
        <Text className={cx(styles.question)} variant="display-5" size="087">
          {question}
        </Text>
        <Text
          className={styles.answer}
          size={fontSizeValue}
          attributes={{
            dangerouslySetInnerHTML: { __html: processedHTML },
            onClick: handleClick,
          }}
        >
          {null}
        </Text>
        <ModalComponents />
      </Grid>
    );
  }

  return (
    <Accordion
      className={cx(styles.accordionItem, styles.question)}
      name={question}
      headerOptions={{
        label: question,
        imageSource: icon,
      }}
    >
      <Text
        className={styles.answer}
        size={fontSizeValue}
        attributes={{
          onClick: handleClick,
          dangerouslySetInnerHTML: { __html: processedHTML },
          'data-testid': `${question.split(' ').join('-')}-answer`,
        }}
      >
        {null}
      </Text>
      <ModalComponents />
    </Accordion>
  );
};
